import PropTypes from "prop-types";
import content from "app-content";
import styles from "./index.css";

const NotifyMeButton = ({
  isButtonShowing,
  isDisabled,
  onClick,
  isOptedIn
}) => (
  <div className={styles.notifyMeButton}>
    {isButtonShowing ? (
      <button disabled={isDisabled} onClick={onClick}>
        {isOptedIn
          ? content.back_in_stock_disable_alert
          : content.back_in_stock_notify_me}
      </button>
    ) : null}
  </div>
);

NotifyMeButton.propTypes = {
  isButtonShowing: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isOptedIn: PropTypes.bool.isRequired
};

export default NotifyMeButton;
